import React, { useEffect, useState } from 'react'
import Button from '../../component/Button'
import classes from "./style.module.scss";
import AdminTableList from './components/AdminTableList';
import CreateAdmin from './components/CreateAdmin';
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
import GetUserPermission from '../../component/GetUserPermission';

const ManageAdminComponent = () => {

    const [createAdmin, setCreateAdmin] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const location = useLocation();
    const navigate = useNavigate();
    const addPermission = GetUserPermission({ key: 'add' });

    useEffect(() => {
        if (location?.pathname) {
            const pathName = location?.search?.split('?type=')
            const params = pathName[pathName?.length - 1]
            if (params) {
                setCreateAdmin(true)
            } else {
                setCreateAdmin(false)
            }
        }
    }, [location])

    const handleChange = (value) => {
        setSearchInput(value)
    }

    const redirectTo = () => {
        navigate(`?type=create`)
    }

    return (
        <>
            {createAdmin ?
                <CreateAdmin /> :
                <div className={`${classes.manageUserWrapper}`}>
                    <div className={`w-[100%] flex items-center justify-between`}>
                        <div className={`layout-title`}>Manage Admin</div>
                        <div className='flex items-center'>
                            <SearchBox value={searchInput} onChange={handleChange} placeholder={'Find by name, type, mobile...'} />
                            {addPermission && <Button text={"Create New Admin"} className={'ml-5'} smallBtn onClick={() => redirectTo()} />}
                        </div>
                    </div>
                    <div>
                        <AdminTableList searchInput={searchInput} />
                    </div>
                </div>
            }

        </>
    )
}

export default ManageAdminComponent